import categories from '../shared/categories';

export const aggregate = expenses => {
  return expenses.reduce(
    (aggr, exp) => {
      const month = new Date(exp.date).getMonth();
      aggr[month] = aggr[month] || { expenses: 0, income: 0, accounts: {} };
      // per month
      aggr[month].expenses += expenseAmount(exp);
      aggr[month].income += incomeAmount(exp);

      aggr[month].accounts[exp.account] = (aggr[month].accounts[exp.account] || 0) - accountDiff([exp], exp.account);
      aggr[month].accounts[exp.toAccount] =
        (aggr[month].accounts[exp.toAccount] || 0) + accountDiff([exp], exp.toAccount);
      aggr[month][categories[exp.category].type] =
        (aggr[month][categories[exp.category].type] || 0) + expenseAmount(exp);
      aggr[month][exp.category] = (aggr[month][exp.category] || 0) + expenseAmount(exp);

      // sums
      aggr.expenses += expenseAmount(exp);
      aggr.income += incomeAmount(exp);
      aggr.accounts[exp.account] = (aggr.accounts[exp.account] || 0) - accountDiff([exp], exp.account);
      aggr.accounts[exp.toAccount] = (aggr.accounts[exp.toAccount] || 0) + accountDiff([exp], exp.toAccount);
      aggr[categories[exp.category].type] = (aggr[categories[exp.category].type] || 0) + expenseAmount(exp);
      aggr[exp.category] = (aggr[exp.category] || 0) + expenseAmount(exp);
      return aggr;
    },
    { accounts: {}, income: 0, expenses: 0 }
  );
};

export const getYear = (expenses, year) => {
  return Object.keys(expenses)
    .map(key => expenses[key])
    .filter(exp => {
      const date = new Date(exp.date);
      return date.getFullYear() === year;
    })
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
};

export const getMonth = (expenses, month, year) => {
  return Object.keys(expenses)
    .map(key => expenses[key])
    .filter(exp => {
      const date = new Date(exp.date);
      return date.getFullYear() === year && date.getMonth() === month;
    })
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
};

export const sumExpenses = expenses => {
  return expenses.reduce((sum, exp) => sum + expenseAmount(exp), 0);
};

export const sumIncome = expenses => {
  return expenses.reduce((sum, exp) => sum + incomeAmount(exp), 0);
};

export const accountDiff = (expenses, accountId) => {
  if (!accountId) {
    return 0;
  }
  return expenses
    .filter(exp => exp.account === accountId || exp.toAccount === accountId)
    .reduce((sum, exp) => sum + exp.value, 0);
};

export const getSign = ({ type, category }) => {
  const { expense, income } = categories[category];
  if (expense && expense > 0) {
    return '';
  } else if (expense && expense < 0) {
    return '-';
  } else if (income) {
    return '';
  } else {
    return '⇄';
  }
};

export const expenseAmount = ({ type, category, value }) => {
  return (categories[category].expense || 0) * value;
};

export const incomeAmount = ({ date, type, category, value }) => {
  return (categories[category].income || 0) * value;
};



// WEBPACK FOOTER //
// ./src/services/expenses.service.ts